import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyGetPatchPointsPacks = async () => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `{
          product(id: "gid://shopify/Product/6798520614935") {
            variants(first: 8) {
              edges {
                node {
                  id
                  title
                  price {
                    amount
                  }
                  image {
                    url(transform: {maxHeight: 100})
                  }
                }
              }
            }
          }
        }`,
      },
    });
    if (response.data.data.product) {
      const { product } = response.data.data;
      return product.variants.edges.map((e) => ({
        id: e.node.id,
        src: e.node.image.url,
        price: parseFloat(e.node.price.amount),
        points: parseInt(e.node.title),
      }));
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyGetPatchPointsPacks;
